import React, { useMemo, useState } from "react";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import AppTableContainer from "@crema/core/AppTableContainer";
import TableHeading from "./TableHeading";
import TableItem from "./TableItem";
import { CmsMasterData } from "types/models/cmsMaster/CmsMasterApp";

interface CmsTableProps {
  cms: CmsMasterData[];
}

type Order = "asc" | "desc";

const CmsTable: React.FC<CmsTableProps> = ({ cms }) => {
  const [order, setOrder] = useState<Order>("asc");
  const [orderBy, setOrderBy] = useState<keyof CmsMasterData>("PageTitle");

  const handleSortRequest = (property: keyof CmsMasterData) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedCms = useMemo(() => {
    return [...cms].sort((a, b) => {
      const aVal = a[orderBy];
      const bVal = b[orderBy];

      if (aVal == null && bVal == null) return 0;
      if (aVal == null) return order === "asc" ? -1 : 1;
      if (bVal == null) return order === "asc" ? 1 : -1;

      return String(aVal).localeCompare(String(bVal)) * (order === "asc" ? 1 : -1);
    });
  }, [cms, order, orderBy]);

  return (
    <AppTableContainer>
      <Table stickyHeader className="table">
        <TableHead>
          <TableHeading order={order} orderBy={orderBy} onSort={handleSortRequest} />
        </TableHead>
        <TableBody>
          {sortedCms.map((data) => (
            <TableItem cms={data} key={data.PageID.toString()} />
          ))}
        </TableBody>
      </Table>
    </AppTableContainer>
  );
};

export default CmsTable;
